import { faCaretDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { displayToast } from 'bundles/connect/helpers/display_toast';
import { updateProfile } from 'bundles/connect/helpers/prospect_api';
import type { NotificationPreferences } from 'bundles/connect/types';
import React, { useState } from 'react';
import { Col, Dropdown, Form, Row } from 'react-bootstrap-5';

type Props = {
  notificationPreference: NotificationPreferences;
}

export default function NotificationSettings({ notificationPreference }: Props) {
  const [offMarketPropertiesDigestEmail, setOffMarketPropertiesDigestEmail] =
    useState(notificationPreference.offMarketPropertiesDigestEmail);
  const [offMarketPropertiesDigestSchedule, setOffMarketPropertiesDigestSchedule] =
    useState(notificationPreference.offMarketPropertiesDigestSchedule);

  const onToggleOffMarketPropertiesDigestEmail = () => {
    updateProfile(
      {
        notificationPreferenceAttributes: {
          offMarketPropertiesDigestEmail: !offMarketPropertiesDigestEmail
        }
      }, 'saved_searches')
      .then(() => {
        setOffMarketPropertiesDigestEmail(!offMarketPropertiesDigestEmail);
        displayToast('Profile updated', 'success');
      });
  };

  const onOffMarketPropertiesDigestScheduleChange = (schedule) => {
    updateProfile(
      { notificationPreferenceAttributes: { offMarketPropertiesDigestSchedule: schedule } }, 'saved_searches')
      .then(() => {
        setOffMarketPropertiesDigestSchedule(schedule);
        displayToast('Profile updated', 'success');
      });
  };

  return (
    <>
      <h5 className="fw-semibold mb-8">Notifications Settings</h5>
      <Row className="align-items-center justify-content-between p-4 border rounded">
        <Col>
          <div className="d-flex align-items-center gap-2">
            <div className="form-check form-switch verbose">
              <input
                checked={offMarketPropertiesDigestEmail}
                className="form-check-input"
                id="toggle_off_market_digest_email"
                role="switch"
                type="checkbox"
                onChange={onToggleOffMarketPropertiesDigestEmail}
              />
            </div>
            <div className="fw-bolder">Saved Searches Updates</div>
          </div>
        </Col>
        <Col xs="auto">
          <Form.Group className="d-flex align-items-center gap-2">
            <Form.Label className="mb-0">Frequency</Form.Label>
            <Dropdown>
              <Dropdown.Toggle disabled={!offMarketPropertiesDigestEmail} variant="outline">
                {offMarketPropertiesDigestSchedule.charAt(0).toUpperCase() + offMarketPropertiesDigestSchedule.slice(1)}
                <FontAwesomeIcon className="px-2" icon={faCaretDown} />
              </Dropdown.Toggle>
              <Dropdown.Menu className="py-0">
                <Dropdown.Item
                  className="border-top-0"
                  onClick={() => onOffMarketPropertiesDigestScheduleChange('weekly')}
                >
                  Weekly
                </Dropdown.Item>
                <Dropdown.Item
                  className="border-bottom-0"
                  onClick={() => onOffMarketPropertiesDigestScheduleChange('monthly')}
                >
                  Monthly
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
}
